import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ISection } from 'phase/section/section';

import { SidebarPlanModule } from '../../coaching-plan.models';

@Component({
	selector: 'spr-phase-section',
	templateUrl: './phase-section.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'block relative p-3',
	},
})
export class PhaseSectionComponent {
	@Input() public section: ISection;

	@Input() public modules: SidebarPlanModule[];

	public trackByModule(index: number, module: SidebarPlanModule): string {
		return module.instance.id;
	}

	public get progress() {
		return (
			(this.modules?.reduce((p, c) => p + (c.isDone ? 1 : 0), 0) /
				(this.modules?.length || 1)) *
				100 ?? 0
		);
	}

	public get isStarted(): boolean {
		return this.modules?.some((m) => m.isStarted || m.isDone) ?? false;
	}
}
